import { useBanquetProps } from 'banquet-runtime-modules'
import { RestaurantInfo } from '../../api/restaurant/getRestaurant'

export const useShowGuestAccounts = (restaurant: RestaurantInfo) => {
  const { featureFlags } = useBanquetProps()
  return restaurant?.country === 'US' && featureFlags?.['nv1-guest-accounts']
}
